import React from 'react'

type Props = {
  [key: string]: any
}

export default function RightArrow({ ...props }: Props) {
  return (
    <svg width='6' height='10' viewBox='0 0 6 10' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M1 9L5 5L1 1' stroke='#17181B' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}
